import { useEffect } from "react";
import { GET_CMS_BY_SLUG } from "../utils/graphql/cms";
import { GET_FORM_BY_SLUG } from "../utils/graphql/form";
import { GET_PRESSROOM_DATA } from "../utils/graphql/pressroomData";
import { GET_BLOG_DATA } from "../utils/graphql/blogData";
import { useQuery } from "@apollo/client";
import URI from "urijs";
import useSlug from "./useSlug";
import { replaceAllVariables } from "../utils/strings";
import { GlobalStore } from "../stores/global";
import metaRobotsIndex from "../utils/metaRobotsIndex";

export function useForms() {
  const { currentCountryCode: countryCode } = GlobalStore.useState(s => s);

  const result = useQuery(GET_FORM_BY_SLUG, {
    variables: { countryCode: countryCode.toUpperCase(), slug: useSlug() }
  });

  const forms = result?.data?.forms;
  let message = forms?.length && forms[0] && forms[0].messageWA;

  useEffect(() => {
    if (message) {
      GlobalStore.update(s => {
        s.whatsappMessage = message;
      });
    }
  }, [message]);

  if (forms) {
    if (forms.length) {
      setTimeout(() => {
        metaRobotsIndex("index");
        window.prerenderReady = true;
      }, 100);
      return forms[0];
    } else return null;
  } else return undefined;
}

export function useCms() {
  const { currentCountry, currentCountryCode: countryCode } = GlobalStore.useState(s => s);

  const { variables } = currentCountry;

  const result = useQuery(GET_CMS_BY_SLUG, {
    variables: {
      countryCode: countryCode.toUpperCase(),
      slug: useSlug() || "home"
    }
  });

  const pages = result?.data?.pages;
  const content = (result?.data?.posts || result?.data?.pressroomArticles) && result.data;
  let message = pages?.length && pages[0] && pages[0].messageWA;

  useEffect(() => {
    if (message) {
      GlobalStore.update(s => {
        s.whatsappMessage = message;
      });
    }
  }, [message]);

  if (pages)
    if (pages.length) {
      setTimeout(() => {
        metaRobotsIndex("index");
        window.prerenderReady = true;
      }, 100);
      return pages[0];
    } else if (content) {
      if (content.pressroomArticles?.length || content.posts.length) {
        setTimeout(() => {
          metaRobotsIndex("index");
          window.prerenderReady = true;
        }, 100);
        return replaceAllVariables(content, variables);
      } else return null;
    } else return undefined;
}

export function usePosts({ tag = undefined, limit = undefined }) {
  const countryCode = GlobalStore.useState(s => s.currentCountryCode);
  const results = useQuery(GET_BLOG_DATA, {
    variables: { limit, tag, countryCode }
  });

  const posts = results?.data?.posts;
  if (posts && posts.length) {
    setTimeout(() => {
      metaRobotsIndex("index");
      window.prerenderReady = true;
    }, 100);
    return posts;
  } else return null;
}

export function useBlog(tabs, tag, page) {
  let perPage = 8;
  const countryCode = GlobalStore.useState(s => s.currentCountryCode);

  const incomingPage = parseInt(page || 1, 10);
  const incomingTag = parseInt(tag || 0, 10);

  let startFrom = 0;

  if (incomingTag === 0) {
    startFrom = perPage * (incomingPage - 1) + 5;
  } else {
    startFrom = perPage * (incomingPage - 1);
  }

  const query = {
    limit: perPage,
    start: startFrom,
    countryCode: countryCode.toUpperCase()
  };
  if (incomingTag !== 0) query.tag = tabs[incomingTag].title.toLowerCase();
  const { data: blogData } = useQuery(GET_BLOG_DATA, { variables: query });
  const posts = blogData && blogData.posts;
  const count = blogData && Math.ceil(blogData.postsConnection.aggregate.count / perPage);
  if (posts)
    setTimeout(() => {
      metaRobotsIndex("index");
      window.prerenderReady = true;
    }, 100);
  return { entries: posts, pageCount: count };
}

export function usePressroom(tabs) {
  const perPage = 6;
  const countryCode = GlobalStore.useState(s => s.currentCountryCode);

  const { page, tag } = new URI().search(true);
  const incomingPage = parseInt(page || 1, 10);
  const incomingTag = parseInt(tag || 0, 10);
  const query = {
    limit: perPage,
    start: perPage * (incomingPage - 1),
    countryCode: countryCode.toUpperCase(),
    tag: incomingTag ? tabs[incomingTag].title.toLowerCase() : tabs[0].title.toLowerCase()
  };
  const { data: pressroomData } = useQuery(GET_PRESSROOM_DATA, { variables: query });
  const articles = pressroomData && pressroomData.articles;
  const count = pressroomData && Math.ceil(pressroomData.pressroomArticlesConnection.aggregate.count / perPage);
  if (articles)
    setTimeout(() => {
      metaRobotsIndex("index");
      window.prerenderReady = true;
    }, 100);
  return { entries: articles, pageCount: count };
}

export function useInfinityPressroom() {
  const countryCode = GlobalStore.useState(s => s.currentCountryCode);

  const query = {
    countryCode: countryCode.toUpperCase()
  };

  const { data: pressroomData } = useQuery(GET_PRESSROOM_DATA, { variables: query });
  var articles = pressroomData && pressroomData.articles;
  if (articles)
    setTimeout(() => {
      metaRobotsIndex("index");
      window.prerenderReady = true;
    }, 100);
  return { entries: articles };
}
